var map = {
	"./arrow_right.svg": "./src/components/nmaModal/icons/arrow_right.svg",
	"./attachment.svg": "./src/components/nmaModal/icons/attachment.svg",
	"./close.svg": "./src/components/nmaModal/icons/close.svg",
	"./document.svg": "./src/components/nmaModal/icons/document.svg",
	"./image.svg": "./src/components/nmaModal/icons/image.svg",
	"./link.svg": "./src/components/nmaModal/icons/link.svg?668c",
	"./pdf.svg": "./src/components/nmaModal/icons/pdf.svg",
	"./video.svg": "./src/components/nmaModal/icons/video.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/nmaModal/icons sync recursive ^\\.\\/.*\\.svg$";